<template>
  <div class="page">
    <navigation @click="showDialog" :customClickEvent="true">
      <span>等待支付订单</span>
    </navigation>
    <main>
      <div class="car">
        <p class="car-title">{{['SC_HY', 'SC1_HY'].includes(this.memberType)?'SVIP':'VIP'}}{{edition}}{{carType}}</p>
        <p class="car-amount"><span class="fz48">¥</span>{{Number(realAmount)|currency}}</p>
        <p class="ori-coast"><span v-if="money">原价：¥{{Number(discountPrice)|currency}}</span></p>
      </div>
      <div class="content">
        <div v-for="(item,index) in list" :key="index" class="item" @click="toSelect(item.type)">
          <div class="left">
            <img class="item-logo" :src="item.type==='WXPAY'?require('./images/icon_weixin@2x.png'):require('./images/icon_zhifubao@2x.png')"/>
            <span class="item-title">{{item.title}}</span>
          </div>
          <img class="item-select" :src="[item.type].includes(type)?require('./images/selected@2x.png'):require('./images/circle_02@2x.png')"/>
        </div>
      </div>
      <div class="content mt20">
        <div class="item"  @click="changeCoupon" v-stat="{ id: 10266, args: {status} }">
          <div class="left">
            <img class="item-logo" src="./images/icon_gouka @2x.png"/>
            <span class="item-title">购卡优惠</span>
          </div>
          <div class="flex-center">
            <span v-if="bool">暂无可用</span>
            <span v-else class="flex-center-money" v-show="money">-¥{{Number(money)|currency}}</span>
            <img class="arrow pl10" src="./images/arrow@2x.png"/>
          </div>
        </div>
      </div>
    </main>
    <footer>
      <nd-button class="button" @click="jump">确定支付</nd-button>
    </footer>
    <nd-dialog v-model="dialog" @close='dialog=false' :footer="false">
      <div class="service-dialog">
        <div class="title">确认要放弃离开吗？</div>
        <div class="description">您的订单还未完成支付，请尽快支付</div>
        <nd-button class="button" @click='dialog=false'>继续本次支付</nd-button>
        <p class="leave" @click="goBack">确认离开</p>
      </div>
    </nd-dialog>
    <div class="weChat" v-show="dialog2" @click="dialog2=false">
      <img src="./images/img_kuang@2x.png" class="finger"/>
    </div>
    <van-popup v-model="showCoupon" position="bottom" :style="{ height: '90%' }">
      <coupon-select :couponList="couponList" @close="close" @selectCouponList="selectCouponList" :discountPrice="discountPrice" :memberType="memberType"/>
    </van-popup>
    <nd-dialog v-model="dialog3" closeBtn :footer="false">
      <div class="service-dialog3">
        <div class="description thick">您当前如需使用微信支付购买，请更新至最新版本。</div>
        <div class="description">您可前往「天美贷-我的」点击「检查更新」进行升级；也可切换支付宝进行购买。</div>
        <div class="flex">
          <nd-button class="btn small" @click="other">切换支付方式</nd-button>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { hasNativeMethod } from '@/assets/jsBridge'
import { mapActions, mapMutations } from 'vuex'
import { getIp, judgeClientSystem, getKey } from '../../assets/utils'
import select from './components/select'
export default {
  name: 'vip-middle',
  customReadyNotify: true,
  data () {
    return {
      discountPrice: Number(this.$route.query.discountPrice), // 传递过来的金额
      memberType: this.$route.query.memberType, // 传递过来的卡类型
      type: this.$route.query.payChanel || '', // 支付类型 支付宝ALIPAY 微博WXPAY
      list: [
        // { title: '微信支付', type: 'WXPAY' },
        { title: '支付宝支付', type: 'ALIPAY' }
      ], // 支付列表
      dialog: false, // 返回弹窗
      dialog2: false, // 跳出微信去浏览器
      dialog3: false, // 安卓之前版本弹出
      vipsName: {
        'BC_M': '月卡', 
        'BC_HY': '半年卡', 
        'BC_Y': '年卡',
        'LC_M': '月卡', 
        'LC_HY': '半年卡', 
        'LC_Y': '年卡',
        'EC_M': '月卡', 
        'EC_HY': '半年卡', 
        'EC_Y': '年卡',
        'SC_HY': '',
        'SC1_HY': ''
      },
      showCoupon: false, // 是否展示优惠券
      couponList: [], // 优惠券列表
      memberGoodsGroupCd: this.$route.query.memberGoodsGroupCd || '', // 当前优惠券类型
      couponRecordId: this.$route.query.couponRecordId || '', // 当前优惠券id
      bool: true, // 是否有可用的券
      status: this.$route.query.status || '' // svip提现引导界面来源
    }
  },
  components: {
    'coupon-select': select
  },
  computed: {
    carType () {
      return this.vipsName[this.memberType] || ''
    },
    // 展示真实金额
    realAmount () {
      return Number(this.discountPrice) - Number(this.money)
    },
    // 展示可减金额
    money () {
      let money = 0
      const { modeType, reducedAmount = 0 } = this.$route.query || {}
      if (modeType === 'continue') { 
        money = Number(reducedAmount)
      } else {
        this.couponList.map((item = {}) => {
          let { isSelected, discountAmt } = item
          if (isSelected && discountAmt) {
            money = money + discountAmt
          }
        })
      }
      return money
    },
    // 展示卡类型
    edition () {
      let obj = { ENJOY: '尊享版', LIGHT_ENJOY: '轻享版' }
      return obj[this.memberGoodsGroupCd] || ''
    }
  },
  async created () {
    let { modeType, couponUseDetail } = this.$route.query || {}
    let obj = JSON.parse(couponUseDetail || '{}') || {}
    if (modeType === 'continue') { 
      let arr = []
      Object.keys(obj).map(item => {
        this.bool = false
        arr.push({ isSelected: true, couponRecordId: item, discountAmt: obj[item] })
      })
      this.couponList = arr
    } else {
      await this.getCouponList()
    }
    this.$report({
      id: 10002,
      args: { target: this.memberGoodsGroupCd, status: this.status, screen: 'page_middle' }
    })
    this.$bus.$emit('ready')
    // this.$message('暂不支持购买', 99999999999)
  },
  // beforeDestroy () {
  //   this.$message('', 1)
  // },
  methods: {
    ...mapActions('activities', [
      'rightsList'
    ]),
    ...mapMutations('user', ['setUserInfo']),
    ...mapActions('vip', [
      'memberInfo'
    ]), 
    // 是否展示弹窗
    changeCoupon () {
      const { modeType } = this.$route.query || {}
      if (modeType !== 'continue') { 
        this.showCoupon = true
      }
    },
    // 关闭弹层
    close () {
      this.showCoupon = false
    },
    // 选择优惠券
    selectCouponList (value) {
      this.couponList = value
    },
    // 获取优惠券列表
    async getCouponList () {
      const { couponRecordId, memberType } = this.$route.query || {}
      let id = couponRecordId ? { couponRecordId: couponRecordId } : {}
      const res = await this.rightsList({
        memberGoodsCd: memberType,
        // amount: discountPrice,
        ...id
      })
      if (res.success) {
        let arr = res.data || []
        arr.map((item = {}) => {
          let { selectInd } = item
          if (selectInd === 'M') {
            item.isSelected = true
            this.bool = false
          }
        })
        this.couponList = arr
      }
    },
    
    // 其它
    other () {
      this.type = 'ALIPAY'
      this.dialog3 = false
    },
    async  jump () {
      this.$report({
        id: 10267,
        args: { position: this.memberGoodsGroupCd, status: this.status }
      })
      const res = await this.memberInfo()
      let { memberStatus, memberNo } = res.data || {}
      if (res.success && memberStatus !== 'EXPIRED' && memberNo) {
        this.$message('暂无购买资格')
      } else if (hasNativeMethod('getUserInfo') && judgeClientSystem() === 'Android' && 
        getKey('appVersion') && getKey('appVersion') < '1.7.3' && this.type === 'WXPAY') {
          this.dialog3 = true
      } else if (navigator.userAgent.toLowerCase().includes('micromessenger')) {
        this.dialog2 = true
      } else if (this.type) {
        const { memberType, host, gid, token, device } = this.$route.query || {}
        const { discountPrice, realAmount } = this
        let couponSerialNos = {}
        this.couponList.map((item = {}) => {
          const { isSelected, couponRecordId, discountAmt } = item
          if (isSelected) {
            couponSerialNos[couponRecordId] = discountAmt
          }
        })
        let payerClientIp = await getIp()
        const userAgent = navigator.userAgent
        const h5SceneType =
          userAgent.indexOf('Android') > -1 ||
          userAgent.indexOf('Adr') > -1 ? 'Android' : 'iOS'
        const number = Number(realAmount).toFixed(2)
        const channel = getKey('channel') || ''
        window.location.href = `${process.env.VUE_APP_PAYURL}?memberType=${memberType}&gid=${gid}&device=${device}&token=${token}&host=${host}&type=${this.type}&payerClientIp=${payerClientIp}&h5SceneType=${h5SceneType}&couponSerialNos=${JSON.stringify(couponSerialNos)}&discountPrice=${discountPrice}&realAmount=${number}&status=${this.status}&channel=${channel}&refurl=${window.location.origin}`
      } else {
        this.$message('请选择付款方式')
      }
    },
    // 选择类型
    toSelect (type) {
      this.$report({
        id: 10167,
        args: { position: type, status: this.status }
      })
      if (type === this.type) {
        this.type = ''
      } else {
        this.type = type
      }
    },
    // 返回上一页
    goBack () {
      this.$router.go(-1)
    },
    // 显示弹窗
    showDialog () {
      // this.dialog = true
      this.$router.go(-1)
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/less/mixin.less";

.page{
  overflow: hidden;
  background-color: #FAFAFA;
  min-height: 100%;
  position:relative;
  main{
    margin-top:30px;
    .car{
      width: 690px;
      // height: 230px;
      background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
      border-radius: 20px;
      margin:auto;
      text-align: center;
      padding-top:50px;
      padding-bottom:24px;
      .fz48{
        font-size: 48px;
        padding-right:9px;
      }
      &-amount{
        height: 67px;
        font-size: 72px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: #763E12;
        line-height: 67px;
      }
      .ori-coast{
        // height: 33px;
        margin-top:16px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #763E12;
        text-decoration:line-through;
      }
      &-title{
        // margin-top:13px;
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #763E12;
        line-height: 33px;
      }
    }
    .content{
      margin:20px auto 0;
      width:690px;
      border-radius: 20px;
      background:#FFF;
      .item{
        position:relative;
        width: 690px;
        height: 110px;
        display: flex;
        justify-content:space-between;
        padding:0 30px;
        align-items: center;
        // background: transparent;
        .left{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .item-logo{
            width:54px;
            height:54px;
          }
          .arrow{
            width:10px;
            height:17px;
          }
          .item-title{
            margin-left:16px;
            height: 42px;
            font-size: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 42px;
          }
        }
        .pl10{
          padding-left:10px;
        }
        .flex-center{
          display: flex;
          align-items:center;
          font-size: 24px;
          &-money{
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF4633;
          }
        }
        &-select{
          width:32px;
          height:32px;
        }
      }
      .mt20{
            margin-top:20px;
          }
      // .item::after{
      //   position: absolute;
      //   bottom:0;
      //   content:'';
      //   width: 620px;
      //   height: 1px;
      //   background: #EEEEEE;
      // }
    }
  }
  .weChat{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index:1001;
    .finger{
      width:572px;
      height:187px;
      position:absolute;
      right:60px;
      top:60px;
    }
  }
  footer{
    position:absolute;
    bottom: 0;
    width: 750px;
    height: 180px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.04);
    padding-top:28px;
    .button{
      width: 650px;
      height: 94px;
      margin: auto;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 47px;
    }
    &.disable{
      .button{
        background: #DDDDDD;
      }
    }
  }
  .service-dialog3{
    text-align: left;
    padding: 0 48px 38px;
    .description {
        margin-top:31px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }
    .thick{
      font-weight: 700 !important;
    }
    .btn {
        width: 300px;
        height: 80px;
        line-height: 80px;
        margin:40px auto 0;
    }
    .grey{
      background:white;
      color:#333;
      border:1px solid #333;
      margin:20px auto 0 !important;
    }
  }
  .service-dialog {
    padding: 31px 48px 38px;
    text-align: center;
    .title {
        height: 59px;
        font-size: 42px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 59px;
    }
    .description {
        margin-top:31px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }
    >.button{
      width: 440px;
      height: 80px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 40px;
      margin:60px auto 0;
    }
    .leave{
      margin-top:22px;
      text-align: center;
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      text-decoration: underline;
    }
  }
}
</style>